import { memo } from 'react';
import { ThumbnailContainer } from '../../../shared';
import { Thumb } from './Thumb';

export const ASSET_WIDTH = 80;

type Props = {
  /** The id of the asset being dragged. */
  assetId: string;
};

/**
 * The DraggingThumbnail component is a slimmed down thumbnail representation
 * that just renders the Thumb itself and disables scrubbing for videos.
 * Intended to be used for representing assets that are being dragged.
 */
export const DraggingThumbnail = memo(({ assetId }: Props) => {
  return (
    <ThumbnailContainer $aspectRatio={'SQUARE'} height={ASSET_WIDTH}>
      <Thumb
        assetId={assetId}
        disableAffordances={{
          commentCount: true,
          scrub: true,
          expiration: true,
        }}
        isImageFitPreferred={false}
      />
    </ThumbnailContainer>
  );
});
